import { AuxiliumComponent } from "../auxilium-component";

export default class Callout extends AuxiliumComponent {
	static observable = ["heading", "variation"];
	static observableBooleans = ["hide-icon"];

	constructor() {
		super();

		this.variation ??= "info";
	}

	parsedCallback() {
		if (this.innerHTML?.trim() === "") { this.classList.add("callout--header-only"); }
		else {
			this.appendChild(document.createElementWithContents("div", this.childNodes, { className: "callout-body" }));
		}

		if (this.heading) {
			this.prepend(document.createElementWithContents("div", this.heading, { className: "callout__header" }));
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "heading") {
			const existing = this.querySelector(".callout__header");

			if (existing) {
				existing.innerHTML = newValue;
			} else {
				this.prepend(document.createElementWithContents("div", newValue, { className: "callout__header" }));
			}
		}
	}
}
